module.exports = __webpack_public_path__ + "img/citysearch.6658d4f5.png";